import { BoxProps, CircularProgress, Flex } from "@chakra-ui/react";

export function Loading(props: BoxProps) {
  return (
    <Flex
      position="absolute"
      top="0"
      left="0"
      width="100vw"
      height="100vh"
      alignItems="center"
      justifyContent="center"
      pointerEvents="none"
      {...props}
    >
      <CircularProgress isIndeterminate color="primary.500" />
    </Flex>
  );
}
